import { type ContentBlockType, PROP_MAP } from './interface';

import { Devices } from '../../service/Devices';
import { cloneElement } from 'react';
import { modifyProps } from '../../generators/modifyProps';

const sizeMap: Record<string, string> = {
  xxs: 'small',
  xs: 'small',
  s: 'small',
  m: 'medium',
  l: 'large',
  xl: 'xtra-large',
  'xtra-small': 'small',
  'xtra-xtra-small': 'small',
  'xtra-large': 'large'
};

export const withLogic =
  (
    Component: React.ComponentType<ContentBlockType>
  ): React.FC<ContentBlockType> =>
  (userProps: ContentBlockType) => {
    const props = modifyProps(userProps, PROP_MAP);
    return (
      <Component
        {...{
          ...props,
          caption: props.caption
            ? cloneElement(props.caption, {
                size: sizeMap[props.size as string] || props.size
              })
            : undefined,
          _hasCaptionSlot: Boolean(props.caption),
          _hasChildrenSlot: Boolean(props.children),
          _platform: Devices.isDesktop() ? 'desktop' : 'mobile'
        }}
      />
    );
  };
export { ContentBlockType };
